module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 643
// module chunks = 29